
export const actions = {
  INITIALIZE: 'initialize',
  UPDATE_SUBCATEGORY: 'update_subcategory',
  REMOVE_SUBCATEGORY: 'remove_subcategory',
  ADD_SUBCATEGORY: 'add_subcategory',
}

export function categoriesReducer(state, { type, payload }) {

  switch (type) {

    case actions.INITIALIZE: {
      return {
        initialized: true,
        categories: payload,
      }
    }

    case actions.REMOVE_SUBCATEGORY: {
      const index = state.categories.findIndex(cat => cat.id === payload.id);
      const newCategories = [...state.categories.slice(0, index), ...state.categories.slice(index+1)];
      return { ...state, categories: newCategories };
    }

    case actions.UPDATE_SUBCATEGORY: {
      const index = state.categories.findIndex(cat => cat.id === payload.id);
      const newCategories = [...state.categories.slice(0, index), payload, ...state.categories.slice(index+1)];
      return { ...state, categories: newCategories };
    }

    case actions.ADD_SUBCATEGORY: {
      return { ...state, categories: [...state.categories, payload] };
    }

    default: {
      return state;
    }

  }
}